import React, { Component } from 'react';
import cn from 'classnames';
import AngleDown from 'react-icons/lib/fa/angle-down';
import styles from './Type.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

const getVariants = (t) => ({
  flat: {
    param: 'flat',
    key: 'apartmentRoom',
    text: t('components.header.filtersBar.filters.type.flat'),
    event: 'Web_Filters_Flat',
  },
  apt: {
    param: 'apt',
    key: 'apartRoom',
    text: t('components.header.filtersBar.filters.type.apt'),
    event: 'Web_Filters_Apartments',
  },
  lvn: {
    param: 'lvn',
    key: 'zhiloeRoom',
    text: t('components.header.filtersBar.filters.type.lvn'),
    event: 'Web_Filters_Zhiloe_Room',
  },
  nlvn: {
    param: 'nlvn',
    key: 'nezhiloeRoom',
    text: t('components.header.filtersBar.filters.type.nlvn'),
    event: 'Web_Filters_Nezhiloe_Room',
  },
  hotelRoom: {
    param: 'hotel',
    key: 'hotelRoom',
    text: t('components.header.filtersBar.filters.type.hotelRoom'),
    event: 'Web_Filters_Hotel_Room',
  },
  zhiloeHouse: {
    param: 'lvnh',
    key: 'zhiloeHouse',
    text: t('components.header.filtersBar.filters.type.zhiloeHouse'),
    event: 'Web_Filters_Zhiloe_House',
  },
  storageRoom: {
    param: 'strg',
    key: 'storageRoom',
    text: t('components.header.filtersBar.filters.type.storageRoom'),
    event: 'Web_Filters_Storage_Room',
  },
});

export const parseSearch = (search, t) => {
  const { type } = search;
  if (!type) {
    return { type: [] };
  }
  const keys = type.split(',');
  const variants = getVariants(t);
  return {
    type: Object.keys(variants).reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.param)) {
        prev.push(variant.key);
      }
      return prev;
    }, []),
  };
};

export const compileSearch = (data, t) => {
  const { type: keys } = data;
  if (!keys || !keys.length) {
    return { type: undefined };
  }
  const variants = getVariants(t);

  return {
    type:
      Object.keys(variants)
        .reduce((prev, cur) => {
          const variant = variants[cur];
          if (keys.includes(variant.key)) {
            prev.push(variant.param);
          }
          return prev;
        }, [])
        .join(',') || undefined,
  };
};

export const compileRequest = (data) => {
  const { type } = data;
  return { typeRoom: type.length ? type : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search, i18n.t));

const countDefinedProps = (obj) => Object.values(obj).filter((value) => value).length;

export const subtext = (search, t) => {
  const { type: keys } = parseSearch(search, t);
  const variants = getVariants(t);
  return (
    Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.text);
        }
        return prev;
      }, [])
      .join(', ') || t('components.header.filtersBar.filters.type.notSelected')
  );
};

class Type extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: true,
    };

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  handleClearClick(e) {
    e.stopPropagation();
    const { dropdownData, mode, profile, objectType, t } = this.props;
    const data = { type: [] };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick('type');

    trackGA(
      gaEvent.filterClearButtonsClick({
        eventContent: 'eshchyo',
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData, mode, objectType, profile, t } = this.props;
    const { type: keys } = parseSearch(search, t);
    const type = [...keys];
    const variants = getVariants(t);

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    const variant = variants[Object.keys(variants).find((v) => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(
      gaEvent.filterCheckboxesClick({
        eventContent: [variantName, ` | ${isChecked}`],
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );

    if (type.includes(key) !== add) {
      if (add) {
        type.push(key);
      } else {
        type.splice(type.indexOf(key), 1);
      }
    }

    const data = { type };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional, t } = this.props;
    const { type } = parseSearch(search, t);
    const variants = getVariants(t);

    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={type.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        additional={additional}
        text={variant.text}
      />
    );
  }

  toggleExpand() {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { type } = parseSearch(search, t);
    const { isExpanded } = this.state;
    const selectedCount = countDefinedProps(type);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <div className={styles.Header} onClick={this.toggleExpand}>
          <span className={styles.Title}>
            {t('components.header.filtersBar.filters.type.title')}
            {selectedCount > 0 && ` (${selectedCount})`}
            <AngleDown className={cn(styles.Icon, { [styles.Active]: isExpanded })} />
          </span>
          {additional && !!type.length && (
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.type.clear')}
            </Button>
          )}
        </div>
        {isExpanded && (
          <div className={styles.Checkboxes}>
            <div className={styles.FirstColumn}>
              {this.checkbox('apt')}
              {this.checkbox('zhiloeHouse')}
              {this.checkbox('nlvn')}
            </div>
            <div className={styles.SecondColumn}>
              {this.checkbox('hotelRoom')}
              {this.checkbox('flat')}
            </div>
            <div className={styles.ThirdColumn}>
              {this.checkbox('lvn')}
              {this.checkbox('storageRoom')}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(Type);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Type/Type.js